<template>
  <div class="parent">
    <div class="layout">
      <div class="title">
        <h1>Your Cart</h1>
        <h2>Total: <CurrencyFormatter :value="total" :currency="currency" /></h2>
      </div>
      <div class="items-parent">
        <template v-if="cart.length > 0">
          <table>
            <thead>
              <tr>
                <th>Product</th>
                <th>Item Price</th>
                <th class="quantity">Quantity</th>
                <th>Price</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in cart" :key="index">
                <td class="product">
                  <img v-if="item.image" :src="item.image" alt="" />
                  <div>
                    <h3>{{ item.name }}</h3>
                    <div class="modifier" v-for="(modifier, index) in Object.keys(item.modifiers)" :key="index">
                      <p v-for="(mod, idx) in item.modifiers[modifier]" :key="idx">{{ mod.name }} <CurrencyFormatter v-if="mod.price > 0" :value="mod.price" :currency="currency" /></p>
                    </div>
                  </div>
                </td>
                <td><CurrencyFormatter :value="item.price" :currency="currency" /></td>
                <td>{{ item.quantity }}</td>
                <td><CurrencyFormatter :value="item.price * item.quantity" :currency="currency" /></td>
              </tr>
              <tr v-if="surcharge">
                <td colspan="3">Surcharge</td>
                <td><CurrencyFormatter :value="surchargeTotal" :currency="currency" /></td>
              </tr>
              <tr v-if="payment.length > 0">
                <td>EFTPOS</td>
                <td colspan="2">{{ payment_message }}</td>
                <td><CurrencyFormatter :value="parseFloat(payment)" :currency="currency" /></td>
              </tr>
            </tbody>
          </table>
        </template>
        <div v-if="!complete && cart.length < 1">
          <h2>Welcome, your order will show up here!</h2>
        </div>
        <div v-if="complete && cart.length === 0" class="thanks">
          <h2>Thanks for your order!</h2>
          <h3>Scan here to generate a receipt!</h3>
          <qr-code id="qr" :contents="qrCode" position-ring-color="var(--text-colour)" position-center-color="var(--action-colour)" module-color="var(--text-colour)">
            <!-- eslint-disable-next-line -->
            <img id="qr-beamy" src="/BeamyIcon.ico" slot="icon" />
          </qr-code>
          <div v-if="timer">
            <p>QR Code will expire in {{ countdown }} seconds</p>
          </div>
        </div>
      </div>
      <h4 class="voidPayment" v-if="getPayapVoided && !getPayapTimeout">Payment Cancelled</h4>
      <h4 class="voidPayment" v-if="getPayapTimeout">Payment Timed Out</h4>
      <div v-if="centrapayEnabled">
        <CentrapayQRCode :lineItems="lineItems" :total="total" :channel="channel" />
      </div>
    </div>
  </div>
</template>

<script>
import { newSocket, api } from "@monolith/helpers";
import CentrapayQRCode from "../components/CentrapayQRCode.vue";
import { CurrencyFormatter } from "@monolith/components";
import { mapGetters } from "vuex";

export default {
  name: "CompanionScreen",
  components: { CentrapayQRCode, CurrencyFormatter },
  data() {
    return {
      total: 0.0,
      cart: [],
      lineItems: [],
      qrCode: "",
      timer: null,
      countdown: 30,
      complete: false,
      surcharge: false,
      surchargeTotal: 0,
      payment: 0,
      Payment_message: "",
      centrapayColor: { dark: "#ffffffff", light: "#2e2f35" },
      payURL: "https://beammeup.nz",
      payapQrcodeShow: false,
      payap: false,
      paymentCancelled: false,
      centrapayEnabled: false,
      channel: null,
    };
  },
  methods: {
    resetQRCode() {
      this.qrCode = "";
      this.complete = false;
      clearInterval(this.timer);
    },

    generateQR(id) {
      console.log("Generating QR code with ID:", id);
      // add /qrcode on end of this.qrCode if wanting to use as image
      this.qrCode = `https://flaskapi-gpvubq4nta-ts.a.run.app/receipt/${window.localStorage.getItem("company")}/${window.localStorage.getItem("site")}/${id}`;
      this.complete = true;
      this.countdown = 30; // Reset the countdown
      this.timer = setInterval(() => {
        this.countdown -= 1;
        if (this.countdown <= 0) {
          this.resetQRCode();
        }
      }, 1000); // Update countdown every second
    },
    animateQR() {
      document.getElementById("qr").addEventListener("codeRendered", () => {
        document.getElementById("qr").animateQRCode("RadialRippleIn");
      });
    },
    setLineItem(doc) {
      this.lineItems = doc.state["products"].map((prod) => {
        return {
          name: prod.name,
          sku: prod.id,
          price: parseInt(prod.quantity * prod.price * 100).toString(),
          qty: prod.quantity.toString(),
          tax: "15.0",
        };
      });
    },
    reduceTotal(doc) {
      this.total = doc.state["products"].reduce((acc, item) => {
        return acc + item.price * item.quantity;
      }, 0);
      this.total += this.surchargeTotal;
    },
  },

  computed: {
    ...mapGetters({
      getPayapVoided: "getPayapVoided",
      getPayap: "getPayap",
      getPayapTimeout: "getPayapTimeout",
      currency: "currency",
    }),
  },

  async mounted() {
    let settings = await JSON.parse(localStorage.getItem("settings"));
    this.centrapayEnabled = settings.centrapay;
  },

  async created() {
    this.$store.dispatch("tokenAction", localStorage.getItem("token"));
    this.$store.dispatch("companyIDAction", localStorage.getItem("company"));

    const companySettings = await api.get('/api/company/get_settings');
    if (companySettings.rows[0].value.currency) {
      this.$store.dispatch("setCurrency", companySettings.rows[0].value.currency);
    }

    await newSocket.setUpChannel(this, this.$store);
    this.channel = this.$.appContext.config.globalProperties.channel;
    this.channel.on("cart:updated", (doc) => {
      this.$store.dispatch("payapVoidedAction", false);
      this.$store.dispatch("payapTimeoutAction", false);
      this.cart = doc.state["products"].map((prod) => {
        return {
          name: prod.name,
          id: prod.id,
          image: prod.image,
          price: prod.price,
          quantity: prod.quantity,
          modifiers: prod.modifiers,
        };
      });
      this.setLineItem(doc);
      if (doc.state.surcharge) {
        this.surcharge = doc.state.surcharge;
        this.surchargeTotal = doc.state.surchargeTotal;
      }
      if (doc.state.payment) {
        this.payment = doc.state.payment;
        this.payment_message = doc.state.payment_message;
      } else {
        this.payment = false;
        this.payment_message = "";
      }
      this.reduceTotal(doc);
    });
    this.channel.on("order:complete", (doc) => {
      this.generateQR(doc.rows[0].id);
    });
    this.channel.on("qrcode:show", (doc) => {
      this.generateQR(doc._id);
    });
    this.channel.on("companion:logout", () => {
      localStorage.clear();
      this.$router.push({ path: "/" });
    });
    this.channel.on("centrapay:init_payment", () => {
      this.$store.dispatch("payapAction", true);
      this.$store.dispatch("payapTimeoutAction", false);
    });
    this.channel.on("centrapay:void_payment", () => {
      this.$store.dispatch("payapAction", false);
    });
    this.channel.on("centrapay:cancel_payment", () => {
      if (!this.getPayapTimeout) {
        this.$store.dispatch("payapAction", false);
        this.$store.dispatch("payapCancelAction", true);
        this.$store.dispatch("payapTimeoutAction", false);
      }
    });
    this.channel.on("centrapay:timeout", () => {
      this.$store.dispatch("payapTimeoutAction", true);
      this.$store.dispatch("payapAction", false);
    });
    this.channel.on("centrapay:paid", (reply) => {
      console.log("Paid", reply);
      this.$store.dispatch("payapPaidAction", true);
      this.$store.dispatch("payapAction", false);
    });
    this.channel.on("company:updated", async () => {
      const settings = await api.get_site_settings(localStorage.getItem("site"));
      localStorage.setItem("settings", JSON.stringify(settings));
      this.centrapayEnabled = settings.centrapay;
    });
  },
  beforeUnmount() {
    this.resetQRCode();
  },
  watch: {
    cart: {
      handler: function (val) {
        if (val.length > 0) {
          this.complete = false;
        }
      },
    },
  },
};
</script>

<style scoped lang="scss">
.parent {
  height: 100vh;
  width: 100vw;
  overflow: hidden;

  .layout {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;

    .voidPayment {
      margin: auto;
      text-transform: uppercase;
    }

    .title {
      display: flex;
      padding: 0.5rem 1rem;
      justify-content: space-between;
      align-items: center;
      h1 {
        font-size: 2rem;
        margin: 0;
      }
    }

    .items-parent {
      overflow-y: scroll;
      padding: 0.5rem 1rem;
      // background-color: var(--secondary-colour);
      height: 90%;
      color: var(--text-colour);

      qr-code {
        margin: auto;
        width: 100%;
        display: flex;
        justify-content: center;

        #qr-beamy {
          width: 100%;
          height: 100%;
          margin: auto;
          display: block;
        }
      }

      table {
        width: 100%;
        border-collapse: separate;
        border-radius: 10px;
        border-spacing: 0 1rem;
        thead {
          // display: block;
          th {
            background-color: var(--action-colour);
            padding: 1rem;
          }
          th:first-child {
            border-radius: 10px 0 0 10px;
          }
          th:last-child {
            border-radius: 0 10px 10px 0;
          }
          .quantity {
            width: 10%;
          }
        }
        tbody {
          th,
          tr {
            text-align: center;
            img {
              width: 3rem;
              border-radius: 5px;
            }
            td:first-child {
              text-align: left;
            }

            .product {
              img {
                margin: 0 2rem;
                position: relative;
                float: left;
              }
              div {
                display: inline-block;
                // position: fixed;
                h3 {
                  margin: 0;
                }
                .modifier {
                  display: block;
                  margin: 0 0.5rem;
                }
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 840px) {
  .parent {
    .layout {
      .items-parent {
        .thanks {
          text-align: center;
          margin: auto;
          h2 {
            margin: 0;
          }
          h3 {
            margin: 0;
            padding: 1rem 0;
          }
          .qr {
            width: 90%;
          }
        }
      }
    }
  }
}
</style>
